import React from 'react';
import { useSelector } from "react-redux";

import Card from '../../../../common/Card';
import AvatarInitials from '../../../../common/AvatarInitials';
import IconClose from './svg/IconClose';

import './CardAction.css';

function CardAction(props) {
  const { count } = props;
  const myBeatportStore = useSelector(state => state.MBStore);
  const storeRoute = useSelector(state => state.storeRoute);

  const click = () => {
    const { id, type } = props;
    myBeatportStore && myBeatportStore.setStateFollow(id, type, myBeatportStore[type.toLowerCase()].includes(id))();
    setTimeout(() => { storeRoute.goTo(`/my-beatport/${type.toLowerCase()}s/${Date.now()}`); }, 200)
  }

  return (
    <Card { ...props } >
       <IconClose className={`card-icon-close`} onClick={click} style={{cursor: `pointer`, position: `absolute`, top: 5, left: 10}} />
       { (count && count > 0) && <AvatarInitials className={`card-action-notif`} name={/*count.toString()*/''} isRound={true} full={true} /> }
    </Card>
  )
}

export default CardAction;
